package nl.volleyplanner.nevoboservice.api

import io.ktor.client.*
import io.ktor.client.plugins.*
import io.ktor.client.request.*
import io.ktor.util.*
import io.ktor.util.logging.*


private val LOGGER = KtorSimpleLogger("nl.volleyplanner.nevoboservice.api.RetainDefaultRequestBaseUrl")

/**
 * Plugin to deal with ktor DefaultRequest disregarding the path in the base URL if the request starts with a slash
 * e.g. with a baseurl of `https://myapi.com/v1/` a request to `/product/1234` would make an
 * actual request to `https://myapi.com/product/1234` instead of `https://myapi.com/v1/product/1234`
 *
 * Related ktor feature request: https://youtrack.jetbrains.com/issue/KTOR-7457
 */
class RetainDefaultRequestBaseUrl {
    companion object Plugin : HttpClientPlugin<Any, RetainDefaultRequestBaseUrl> {
        override val key: AttributeKey<RetainDefaultRequestBaseUrl> = AttributeKey("RetainDefaultRequestBaseUrl")

        override fun prepare(block: Any.() -> Unit): RetainDefaultRequestBaseUrl {
            return RetainDefaultRequestBaseUrl()
        }

        override fun install(plugin: RetainDefaultRequestBaseUrl, scope: HttpClient) {
            scope.requestPipeline.intercept(HttpRequestPipeline.Before) {
                if (context.url.pathSegments.size > 1 && context.url.pathSegments.first().isEmpty()) {
                    val originalUrl = context.url
                    context.url.pathSegments = context.url.pathSegments.drop(1)
                    LOGGER.info("Updated URL $originalUrl to ${context.url} in order to retain the Base URL path from DefaultRequest")
                }
            }
        }
    }
}